module.exports = __webpack_public_path__ + "img/165.2618d0fc.png";